import { useMemo, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { ITab } from '@/store/models/profile.model';

type TProps = {
  items: ITab[];
};

export function useNavigationTabs({ items }: TProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const currentTabIndex = useMemo(() => items.findIndex(({ id }) => pathname.includes(id)) || 0, [items, pathname]);

  const handleRouteChange = useCallback(
    (tabIndex: number) => {
      const currentRoute = items[tabIndex];
      currentRoute && navigate(currentRoute.path);
    },
    [navigate, items],
  );

  return { currentTabIndex, handleRouteChange };
}
